import React from 'react';
import SectionHeader from './common/section-header';
import diSystemsLogo from '../assets/itpartner/di-Systems_Logo_1024x576_trans.svg';
import { HoverPeek } from '@/components/ui/link-preview';

const ClientsSection = () => {
  // Partner logos with their URLs
  const partnerLogos = [
    { 
      name: "Osram", 
      id: 2, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/6/63/Osram_Logo.svg" 
    },
    { 
      name: "Philips", 
      id: 3, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/8/8c/Philips_logo.svg" 
    },
    { 
      name: "AVM", 
      id: 4, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/8/8f/AVM_logo_%281986-2025%29.svg" 
    },
    { 
      name: "Gira", 
      id: 5, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/2/20/Logo_Gira_Giersiepen.svg" 
    },
    { 
      name: "Hager", 
      id: 6, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a7/Hager_Group_Logo_grey.png" 
    },
    { 
      name: "ABB", 
      id: 7, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/0/00/ABB_logo.svg" 
    },
    { 
      name: "Schneider Electric", 
      id: 8, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/4/49/Schneider-Electric-Logo.jpg" 
    },
    { 
      name: "Fronius", 
      id: 9, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/2/2e/Fronius-logo.png" 
    },
    { 
      name: "SMA", 
      id: 10, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f8/Logo_SMA.svg" 
    },
    { 
      name: "Huawei", 
      id: 11, 
      logoUrl: "https://upload.wikimedia.org/wikipedia/de/c/c2/Huawei-Logo.svg" 
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="space-y-12">
          <div>
            <div className="text-center mb-8">
              <h3 className="text-xl font-semibold mt-0 mb-4">Wir verwenden ausschließlich Produkte namhafter Hersteller wie:</h3>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 sm:gap-6 w-full">
              {partnerLogos.map((partner) => (
                <div 
                  key={partner.id} 
                  className="bg-white h-16 sm:h-24 rounded-lg shadow-sm flex items-center justify-center border border-border p-2 sm:p-4 transition-all duration-300 hover:scale-105 hover:shadow-md hover:border-primary/20 group"
                >
                  <img 
                    src={partner.logoUrl} 
                    alt={`${partner.name} logo`} 
                    className="max-h-full max-w-full object-contain opacity-70 group-hover:opacity-100 transition-opacity duration-300" 
                  />
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="text-center mb-0 mt-16">
              <h3 className="text-xl font-semibold">
                Starker Partner für IT und SmartHome:{' '}
                <HoverPeek url="https://di-systems.de/">
                  <a 
                    href="https://di-systems.de/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#D80413] hover:underline"
                  >
                    di-Systems
                  </a>
                </HoverPeek>
              </h3>
            </div>
            <div className="bg-white p-6 md:p-8 lg:p-12 rounded-lg shadow-lg w-full mx-auto">
              <div className="flex flex-col md:flex-row items-center gap-8 md:gap-16 max-w-5xl mx-auto">
                <img 
                  src={diSystemsLogo}
                  alt="diSystems Logo" 
                  className="h-24 md:h-32 w-48 md:w-64 object-contain flex-shrink-0 transition-transform duration-300 hover:scale-110"
                />
                <div className="flex-grow text-center md:text-left">
                  <p className="text-paragraph text-justify text-align-last-none">
                    Für die IT-Betreuung und Unterstützung bei komplexen IT-Themen setzen wir auf die Expertise von di-Systems. 
                    Als zuverlässiger Partner begleitet uns di-Systems insbesondere bei der Integration von Smart-Home-Systemen 
                    sowie der Implementierung moderner IT-Lösungen.
                  </p>
                  <HoverPeek url="https://di-systems.de/">
                    <a 
                      href="https://di-systems.de/" 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="font-semibold transition-all duration-300 mt-4 inline-block hover:scale-110 hover:text-primary"
                      style={{ color: '#D80413' }}
                    >
                      di-Systems | Ihr regionaler IT-Dienstleister
                    </a>
                  </HoverPeek>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
